let language = {
    RETURNS_FILTER_NO: "订单编号",
    RETURNS_FILTER_RETURN: "退货编号",
    RETURNS_FILTER_STATUS: "状态",
    RETURNS_FILTER_RESET: "重置",
    RETURNS_FILTER_SEARCH: "搜索"
}

export { language }
